var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91671 11.25H17.0834M7.16671 20.5016H11.8334L17.0251 23.955C17.7951 24.4683 18.8334 23.92 18.8334 22.9866V20.5016C22.3334 20.5016 24.6667 18.1683 24.6667 14.6683V7.66829C24.6667 4.16829 22.3334 1.83496 18.8334 1.83496H7.16671C3.66671 1.83496 1.33337 4.16829 1.33337 7.66829V14.6683C1.33337 18.1683 3.66671 20.5016 7.16671 20.5016Z",
    stroke: "#292B30",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatButtonIcon);
export default __webpack_public_path__ + "static/media/chat-button-icon.22e693555bed2264ce4e614b07bbf7a3.svg";
export { ForwardRef as ReactComponent };